import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';
import { useFonts } from '@/composables/fonts';
import FontSelector from '../FontSelector.vue';
import type { CSelectItem, Primitive } from '@/components/shared/CSelect';
import { findFontByUrl, fontUrlFromPath } from './calendarUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarFontField',
  props: {
    value: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    /** Absolute font url as stored in the calendar config. */
    value?: string;
    disabled?: boolean;
};





const { generateFontName } = useFonts();

const selected = computed<CSelectItem<string> | undefined>(() => {
    const font = findFontByUrl(store.state.userFonts, props.value);
    return font ? { label: generateFontName(font), value: font.Path } : undefined;
});

const onFontSelected = (item?: CSelectItem<Primitive>) => {
    if (!item?.value) return;
    emit('input', fontUrlFromPath(String(item.value)));
};

return { __sfc: true,props, emit, generateFontName, selected, onFontSelected, FontSelector }
}

})